import { Routes } from '@angular/router'

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.routes').then((m) => m.routes),
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./pages/home/home.page').then((m) => m.HomePage),
  },
  {
    path: 'thematic-area',
    loadComponent: () =>
      import('./pages/thematic-area/thematic-area.page').then(
        (m) => m.ThematicAreaPage
      ),
  },
  {
    path: 'points-of-interest',
    loadComponent: () =>
      import('./pages/points-of-interest/points-of-interest.page').then(
        (m) => m.PointsOfInterestPage
      ),
  },
  {
    path: 'news',
    loadComponent: () =>
      import('./pages/news/news.page').then((m) => m.NewsPage),
  },
  {
    path: 'poi-details-page',
    loadComponent: () =>
      import('./pages/poi-details-page/poi-details-page.page').then(
        (m) => m.PoiDetailsPage
      ),
  },
  {
    path: 'itineraries',
    loadComponent: () =>
      import('./pages/itineraries/itineraries.page').then(
        (m) => m.ItinerariesPage
      ),
  },
  {
    path: 'itinerary-details-page',
    loadComponent: () =>
      import(
        './components/tours/itinerary-details-page/itinerary-details-page.page'
      ).then((m) => m.ItineraryDetailsPagePage),
  },
  {
    path: 'gal',
    loadComponent: () => import('./pages/gal/gal.page').then((m) => m.GALPage),
  },
  {
    path: 'news-page-detail',
    loadComponent: () =>
      import('./pages/news-page-detail/news-page-detail.page').then(
        (m) => m.NewsPageDetailPage
      ),
  },
  {
    path: 'terms',
    loadComponent: () =>
      import('./pages/terms/terms.page').then((m) => m.TermsPage),
  },
  {
    path: 'desktop-home',
    loadComponent: () =>
      import('./pages/around-me/around-me.page').then((m) => m.AroundMePage),
  },
  {
    path: 'privacy',
    loadComponent: () =>
      import(
        './components/page-template/desktop/children/privacy/desktop-privacy.component'
      ).then((m) => m.DesktopPrivacyComponent),
  },
]
